/* ==============================================================================
   LUZGURU ACCORDION WEB COMPONENT
   Asset: assets/lg-accordion.js
============================================================================== */

if (!customElements.get('lg-accordion')) {
  customElements.define('lg-accordion', class extends HTMLElement {
    constructor() {
      super();
      this.item = this.querySelector('.lg-accordion-item');
      if (!this.item) return;

      this.pageReady = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => { this.pageReady = true; });
      });

      this.item.addEventListener('toggle', this.onToggle.bind(this));
    }

    onToggle() {
      if (!this.item.open || !this.pageReady) return;
      requestAnimationFrame(() => {
        const top = this.item.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }
  });
}
